const heroBanner = '/images/home/hero.png';
const years20 = '/images/home/20-years.png';
const years20Mobile = '/images/home/20-years-mobile.png';
const educational = '/images/home/educational.png';
const contactBanner = '/images/home/contact-banner.png';
const ieltsMaster = '/images/partners/ielts-master.png';
const mottoFrame = '/images/home/motto-frame.png';
const proudBanner = '/images/home/proud-banner.png';
const proudCardFrame = '/images/home/proud-card-frame.png';
const reasonBanner = '/images/about/reason-banner.png';
const reasonBanner1 = '/images/about/reason-banner-1.png';
const reasonBanner2 = '/images/about/reason-banner-2.png';
const reasonBanner3 = '/images/about/reason-banner-3.png';
const reasonFrame = '/images/about/reason-frame.png';
const journeyFrame = '/images/about/journey-frame.png';
const journeyFrame1 = '/images/about/journey-frame-1.png';
const lecturerImg = '/images/about/lecturer-img.png';
const factorialBanner = '/images/about/factorial-banner.png';
const courseImg = '/images/about/course-img.png';
const courseDetailBanner = '/images/course/course-banner.png';
const courseBanner = '/images/home/course-banner.png';
const detailNavImage = '/images/common/detail-nav-image.png';
const prBanner1 = '/images/article/pr-banner-1.png';
const prBanner2 = '/images/article/pr-banner-2.png';

const common = { detailNavImage };
const home = {
	heroBanner,
	years20,
	years20Mobile,
	educational,
	courseBanner,
	ieltsMaster,
	mottoFrame,
	proudBanner,
	proudCardFrame,
	contactBanner,
};

const about = {
	reasonBanner,
	reasonFrame,
	journeyFrame,
	journeyFrame1,
	lecturerImg,
	factorialBanner,
	courseImg,
	reasonBanner1,
	reasonBanner2,
	reasonBanner3,
};

const course = {
	courseDetailBanner,
};

const article = {
	prBanner1,
	prBanner2,
};

export const Images = {
	common,
	home,
	about,
	course,
	article,
};
